import { Stack, Typography, useTheme } from "@mui/material";
import type { FC } from "react";

type Props = {
	title: string;
};

export const DetailSectionHeader: FC<Props> = ({ title }) => {
	const theme = useTheme();

	return (
		<Stack
			direction="row"
			alignItems="center"
			gap={theme.spacingTokens.sm}
			px={theme.spacingTokens.lg}
			pt={2.4}
			pb={theme.spacingTokens.sm}
		>
			<Typography variant="overline" color={theme.palette.grey[600]}>
				{title}
			</Typography>
		</Stack>
	);
};
